import React, { ChangeEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  Tabs,
  Tab,
  Box,
  TextField,
  CardMedia,
  Input,
} from "@mui/material";
import EditText from "../../components/editText";
import AddFaq from "../../Modals/addFaq";
import AddIcon from "@mui/icons-material/Add";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import CloseIcon from "@mui/icons-material/Close";
import SwitchToggle from "../../components/SwitchToggle";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCms = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const [legal2, setLegal2] = useState<string>("");
  const [legal3, setLegal3] = useState<string>("");
  const [legal4, setLegal4] = useState<string>("");

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const [error, setError] = useState(false);
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [image2, setImage2] = useState<string>("");

  const [fileName, setFileName] = useState<string>("");
  const [color, setColor] = useState("#0CD0C6");
  return (
    <>
      <div className="main_title">
        <h1>Manage CMS</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Manage CMS
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Contact Support" {...a11yProps(0)} />
              <Tab label="Legal" {...a11yProps(1)} />
              <Tab label="Terms & Conditions" {...a11yProps(2)} />
              <Tab label="Privacy Policy" {...a11yProps(3)} />
              <Tab label="FAQ's" {...a11yProps(4)} />
              <Tab label="Theme  Settings" {...a11yProps(5)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <form className="form">
            <div className="gap_p">
              <div className="control_group w_50">
                <label htmlFor="email">Email Address</label>
                <TextField
                  id="email"
                  placeholder="Enter here"
                  fullWidth
                  hiddenLabel
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {error && email == "" ? (
                  <h6 className="err_msg">Email is required</h6>
                ) : (
                  ""
                )}
              </div>
              <div className="control_group w_50">
                <label htmlFor="phone">Phone Number</label>
                <PhoneInput
                  country={"in"}
                  placeholder="Enter Phone Number"
                  enableSearch={false}
                  autoFormat={false}
                  inputStyle={{ width: "100%" }}
                />
              </div>
            </div>
            <div className="form_btn">
              <Button
                className="btn btn_primary"
                onClick={() => {
                  setError(true);
                  if (email == "") return;
                  if (phone == "") return;
                  setError(false);
                }}
              >
                Save
              </Button>
            </div>
          </form>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <EditText content={legal2} setContent={setLegal2} />
          <div className="form_btn">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <EditText content={legal3} setContent={setLegal3} />
          <div className="form_btn">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={3}>
          <EditText content={legal4} setContent={setLegal4} />
          <div className="form_btn">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={4}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
            </div>
            <div className="right_s">
              <Button
                className="btn btn_primary"
                onClick={() => {
                  setIsEdit(false);
                  setOpenModal(true);
                }}
              >
                <AddIcon /> Add FAQ
              </Button>
            </div>
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Sr.no</TableCell>
                  <TableCell>Question</TableCell>
                  <TableCell>Answer</TableCell>
                  <TableCell>Created Date</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow hover>
                  <TableCell>1</TableCell>
                  <TableCell>FAQ title here</TableCell>
                  <TableCell className="max_c2">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry.
                    </p>
                  </TableCell>
                  <TableCell>12 Jan 2024</TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => setOpenModal(true)}>
                        <img src="/static/images/edit2_icon.svg" alt="" />
                      </IconButton>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow hover>
                  <TableCell>2</TableCell>
                  <TableCell>FAQ title here</TableCell>
                  <TableCell className="max_c2">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry.
                    </p>
                  </TableCell>
                  <TableCell>12 Jan 2024</TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton
                        onClick={() => {
                          setIsEdit(false);
                          setOpenModal(true);
                        }}
                      >
                        <img src="/static/images/edit2_icon.svg" alt="" />
                      </IconButton>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow hover>
                  <TableCell>3</TableCell>
                  <TableCell>FAQ title here</TableCell>
                  <TableCell className="max_c2">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry.
                    </p>
                  </TableCell>
                  <TableCell>12 Jan 2024</TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => setOpenModal(true)}>
                        <img src="/static/images/edit2_icon.svg" alt="" />
                      </IconButton>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow hover>
                  <TableCell>4</TableCell>
                  <TableCell>FAQ title here</TableCell>
                  <TableCell className="max_c2">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry.
                    </p>
                  </TableCell>
                  <TableCell>12 Jan 2024</TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => setOpenModal(true)}>
                        <img src="/static/images/edit2_icon.svg" alt="" />
                      </IconButton>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow hover>
                  <TableCell>5</TableCell>
                  <TableCell>FAQ title here</TableCell>
                  <TableCell className="max_c2">
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry.
                    </p>
                  </TableCell>
                  <TableCell>12 Jan 2024</TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => setOpenModal(true)}>
                        <img src="/static/images/edit2_icon.svg" alt="" />
                      </IconButton>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={5}>
          <form className="form">
            <div className="gap_p">
              <div className="control_group">
                <div className="gap_">
                  <div className="control_group w_33">
                    <label htmlFor="icon-button-file">Upload App Logo</label>
                    {image ? (
                      <div className="upload_image  no_radius">
                        <div className="upload_image_holder">
                          <figure>
                            <CardMedia
                              component="img"
                              image={image}
                              alt="Uploaded profile photo"
                            />
                          </figure>
                          <IconButton
                            aria-label="Remove uploaded image"
                            onClick={() => {
                              setImage("");
                              setFileName("");
                            }}
                            size="small"
                          >
                            <CloseIcon />
                          </IconButton>
                        </div>
                      </div>
                    ) : (
                      <label
                        className="upload_image  no_radius"
                        htmlFor="icon-button-file"
                      >
                        <Input
                          sx={{ display: "none" }}
                          id="icon-button-file"
                          type="file"
                          inputProps={{ accept: "image/png,image/jpeg" }}
                          onChange={(event: ChangeEvent<HTMLInputElement>) => {
                            const files = (event.target as HTMLInputElement)
                              .files;
                            if (files && files[0].type.includes("image")) {
                              setFileName(files[0].name);
                              setImage(URL.createObjectURL(files[0]));
                            } else {
                              setAlertType(0);
                              setShowAlert(true);
                              setAlertMessage(
                                "This field only accepts images."
                              );
                            }
                          }}
                        />
                        <span className="upload_image_holder">
                          <figure className="add_img">
                            <img
                              src="/static/images/placeholder.png"
                              alt="placeholder"
                            />
                            <span className="upload_img_icon">
                              <img
                                src="/static/images/edit2_icon.svg"
                                alt="Upload"
                              />
                            </span>
                          </figure>
                        </span>
                      </label>
                    )}
                  </div>
                </div>
              </div>
              <div className="control_group  w_50">
                <label htmlFor="email">Background Color</label>
                <div className="color_value">
                  <TextField
                    type="color"
                    placeholder="Enter here"
                    value={color}
                    onChange={(e) => setColor(e.target.value)}
                    fullWidth
                    hiddenLabel
                  />
                  <p>{color}</p>
                </div>
              </div>
            </div>
            <div className="section_title subTitle">
              <h2>Upload Splash Images</h2>
            </div>
            <div className="gap_">
              <div className="control_group w_100">
                <label htmlFor="icon-button-file"> Images</label>

                <div className="gap_p">
                  {[0, 1, 2].map((index) => (
                    <div className="control_group w_33" key={index}>
                      {image2 ? (
                        <div className="upload_image v2 no_radius">
                          <div className="upload_image_holder">
                            <figure>
                              <CardMedia
                                component="img"
                                image={image2}
                                alt="Uploaded profile photo"
                              />
                            </figure>
                            <IconButton
                              aria-label="Remove uploaded image"
                              onClick={() => {
                                setImage("");
                                setFileName("");
                              }}
                              size="small"
                            >
                              <CloseIcon />
                            </IconButton>
                          </div>
                        </div>
                      ) : (
                        <label
                          className="upload_image v2  no_radius"
                          htmlFor="icon-button-file"
                        >
                          <Input
                            sx={{ display: "none" }}
                            id="icon-button-file"
                            type="file"
                            inputProps={{ accept: "image/png,image/jpeg" }}
                            onChange={(
                              event: ChangeEvent<HTMLInputElement>
                            ) => {
                              const files = (event.target as HTMLInputElement)
                                .files;
                              if (files && files[0].type.includes("image")) {
                                setFileName(files[0].name);
                                setImage(URL.createObjectURL(files[0]));
                              } else {
                                setAlertType(0);
                                setShowAlert(true);
                                setAlertMessage(
                                  "This field only accepts images."
                                );
                              }
                            }}
                          />
                          <span className="upload_image_holder">
                            <figure className="add_img">
                              <img
                                src="/static/images/placeholder.png"
                                alt="placeholder"
                              />
                              <span className="upload_img_icon">
                                <img
                                  src="/static/images/edit2_icon.svg"
                                  alt="Upload"
                                />
                              </span>
                            </figure>
                          </span>
                        </label>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="section_title subTitle">
              <h2>Upload GIF & Video</h2>
            </div>
            <div className="gap_">
              <div className="control_group w_100">
                <div className="gap_p">
                  <div className="control_group w_33">
                    <label htmlFor="icon-button-file" className="flex">
                      {" "}
                      <span> GIF</span> <SwitchToggle />{" "}
                    </label>
                    {image2 ? (
                      <div className="upload_image v2 no_radius">
                        <div className="upload_image_holder">
                          <figure>
                            <CardMedia
                              component="img"
                              image={image2}
                              alt="Uploaded profile photo"
                            />
                          </figure>
                          <IconButton
                            aria-label="Remove uploaded image"
                            onClick={() => {
                              setImage("");
                              setFileName("");
                            }}
                            size="small"
                          >
                            <CloseIcon />
                          </IconButton>
                        </div>
                      </div>
                    ) : (
                      <label
                        className="upload_image v2  no_radius"
                        htmlFor="icon-button-file"
                      >
                        <Input
                          sx={{ display: "none" }}
                          id="icon-button-file"
                          type="file"
                          inputProps={{ accept: "image/png,image/jpeg" }}
                          onChange={(event: ChangeEvent<HTMLInputElement>) => {
                            const files = (event.target as HTMLInputElement)
                              .files;
                            if (files && files[0].type.includes("image")) {
                              setFileName(files[0].name);
                              setImage(URL.createObjectURL(files[0]));
                            } else {
                              setAlertType(0);
                              setShowAlert(true);
                              setAlertMessage(
                                "This field only accepts images."
                              );
                            }
                          }}
                        />
                        <span className="upload_image_holder">
                          <figure className="add_img">
                            <img
                              src="/static/images/placeholder.png"
                              alt="placeholder"
                            />
                            <span className="upload_img_icon">
                              <img
                                src="/static/images/edit2_icon.svg"
                                alt="Upload"
                              />
                            </span>
                          </figure>
                        </span>
                      </label>
                    )}
                  </div>
                  <div className="control_group w_33">
                    <label htmlFor="icon-button-file" className="flex">
                      {" "}
                      <span> Video</span> <SwitchToggle />{" "}
                    </label>
                    {image2 ? (
                      <div className="upload_image v2 no_radius">
                        <div className="upload_image_holder">
                          <figure>
                            <CardMedia
                              component="img"
                              image={image2}
                              alt="Uploaded profile photo"
                            />
                          </figure>
                          <IconButton
                            aria-label="Remove uploaded image"
                            onClick={() => {
                              setImage("");
                              setFileName("");
                            }}
                            size="small"
                          >
                            <CloseIcon />
                          </IconButton>
                        </div>
                      </div>
                    ) : (
                      <label
                        className="upload_image v2  no_radius"
                        htmlFor="icon-button-file"
                      >
                        <Input
                          sx={{ display: "none" }}
                          id="icon-button-file"
                          type="file"
                          inputProps={{ accept: "image/png,image/jpeg" }}
                          onChange={(event: ChangeEvent<HTMLInputElement>) => {
                            const files = (event.target as HTMLInputElement)
                              .files;
                            if (files && files[0].type.includes("image")) {
                              setFileName(files[0].name);
                              setImage(URL.createObjectURL(files[0]));
                            } else {
                              setAlertType(0);
                              setShowAlert(true);
                              setAlertMessage(
                                "This field only accepts images."
                              );
                            }
                          }}
                        />
                        <span className="upload_image_holder">
                          <figure className="add_img">
                            <img
                              src="/static/images/placeholder.png"
                              alt="placeholder"
                            />
                            <span className="upload_img_icon">
                              <img
                                src="/static/images/edit2_icon.svg"
                                alt="Upload"
                              />
                            </span>
                          </figure>
                        </span>
                      </label>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="btn_flex">
              <Button className="btn btn_primary">Submit</Button>
            </div>

          </form>
        </CustomTabPanel>
      </div>

      <AddFaq
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default ManageCms;
